export default "__VITE_ASSET__Cz$eBY3n__"